<template>
  <div
    v-editable="blok"
    class="MarqueeBannerBlock heroIfFirst"
    :class="{
      [desktopWidth('full')]: !blok.fullWidth,
      'w-screen': blok.fullWidth,
    }"
  >
    <client-only>
      <Vue3Marquee
        :clone="true"
        :duration="stationary ? 0 : Number(duration)"
        class="w-full my-2 h-32 flex items-center select-none"
        :class="{
          'text-lightest': blok.marqueeWhiteTextColor,
        }"
        :style="`background-color: ${blok.marqueeBackgroundColor.color}`"
      >
        <div class="my-2 h-32 flex items-center">
          <div
            v-for="item in props.blok.marqueeItemList"
            :key="item._uid"
            class="whitespace-nowrap transition mr-16 desk:mr-24 type-tagline-xxs desk:type-tagline font-semibold odd:font-light"
          >
            {{ item.text }}
          </div>
        </div>
      </Vue3Marquee>
    </client-only>
  </div>
</template>

<script lang="ts" setup>

import {
  SiteMarqueeItem,
  StoryBlokColorpicker,
  StoryBlokPropBase
} from '~/constants/types/storyblok';
import useVisualAppearancePlugin from '~/composeables/useVisualAppearancePlugin';
import { Vue3Marquee } from 'vue3-marquee';

type Props = StoryBlokPropBase & {
  marqueeWhiteTextColor: boolean;
  marqueeItemList: SiteMarqueeItem[];
  marqueeBackgroundColor: StoryBlokColorpicker;
  fullWidth: boolean;
  stationary: boolean;
  marqueeSpeed: number | string,
}

const props = defineProps<{
  blok: Props,
}>();

const stationary = computed(() => props.blok.stationary);

const duration = ref(props.blok.marqueeSpeed || 10); // Default to 10 if not present

const { desktopWidth } = useVisualAppearancePlugin(props);
</script>
